import api from "../api";

export const StudentLogin = async ({username, password}) => {
    try {
        const { data } = await api.post(`/student/login`, {username, password})

        return data;
    } catch (error) {
        throw error.response.data;
    }
}

export const GetStudentDetails = async (id) => {
    try {
        const { data } = await api.get(`/students/students/${id}/`)

        return data;
    } catch (error) {
        throw error.response.data;
    }
}

export const GeneralPaymentDetails = async () => {
    try {
        const { data } = await api.get(`/setup/view/fees/`)

        return data;
    } catch (error) {
        throw error.response.data;
    }
}
export const InitiateSchoolFeePayment = async ({student_id, payment_type, custom_amount, session_id}) => {
    try {
        const { data } = await api.post(`/payments/student-fees/${student_id}/pay/`, {student_id, payment_type, custom_amount, session_id})

        return data;
    } catch (error) {
        throw error.response.data;
    }
}


export const InitiateOtherFeePayment = async ({student_id, payment_option, payment_level, payment_session}) => {
    try {
        const { data } = await api.post(`/payments/other-fee/pay/`, {student_id, payment_option, payment_level, payment_session})

        return data;
    } catch (error) {
        throw error.response.data;
    }
}

export const InitiateMedicalFeePayment = async ({student, payment_type, custom_amount, session}) => {
    try {
        const { data } = await api.post(`/payments/medical-fee/pay/`, {student, payment_type, custom_amount, session})

        return data;
    } catch (error) {
        throw error.response.data;
    }
}

export const VerifyPayments = async (ref) => {
    try {
        const data = await api.get(`/payments/verify/${ref}/`)

        return data;
    } catch (error) {
        throw error.response.data;
    }
}